import React, { SVGProps } from 'react';

const VehicleConditionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.0022 11.6675C16.8439 11.6675 18.3369 13.1605 18.3369 15.0022C18.3369 16.8439 16.8439 18.3369 15.0022 18.3369C13.1605 18.3369 11.6675 16.8439 11.6675 15.0022C11.6675 13.1605 13.1605 11.6675 15.0022 11.6675"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.126 14.4412L14.7221 15.8492L13.8784 15.0022"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.93541 9.55917H5.16968" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.046 9.55917H12.2803" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.929 6.91046L16.6939 6.02759" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.28698 6.91046L2.52124 6.02759" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.73533 2.49707C5.91487 2.49716 5.20246 3.06211 5.01545 3.86097L4.26514 7.0623L5.01545 3.86097C5.20246 3.06211 5.91487 2.49716 6.73533 2.49707H12.4802C13.3006 2.49693 14.0129 3.06207 14.1993 3.86097L14.9496 7.0623"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6938 10.0002V9.34155C16.6938 8.03846 15.6384 6.98158 14.3353 6.97974H4.88389C4.25735 6.97952 3.6564 7.22825 3.2133 7.6712C2.77019 8.11415 2.52124 8.71502 2.52124 9.34155V13.3349C2.52124 13.7953 2.89449 14.1686 3.35492 14.1686H5.21903C5.67946 14.1686 6.05271 13.7953 6.05271 13.3349V12.2069H10.0002"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VehicleConditionIcon;
